import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useTransactionCategoryStore = defineStore('transactionCategory', {
  state: () => ({
    transactionCategories: {},
    unsubs: [],
  }),
  persist: { paths: ['transactionCategories'] },
  getters: {
    allTransactionCategories(state) {
      return Object.values(state.transactionCategories)
        .filter((c) => c.isActive !== false)
        .sort((a, b) => {
          const orderA = Number(a.order) || 0;
          const orderB = Number(b.order) || 0;
          if (orderA !== orderB) return orderA - orderB;
          return (a.name || '').localeCompare(b.name || '');
        });
    },
    categoriesByKind: (state) => (kind) =>
      Object.values(state.transactionCategories)
        .filter((c) => c.isActive !== false && c.kind === kind)
        .sort((a, b) => {
          const orderA = Number(a.order) || 0;
          const orderB = Number(b.order) || 0;
          if (orderA !== orderB) return orderA - orderB;
          return (a.name || '').localeCompare(b.name || '');
        }),
  },
  actions: {
    upsert({ id, value }) {
      this.transactionCategories = { ...this.transactionCategories, [id]: value };
    },
    remove(id) {
      const transactionCategories = { ...this.transactionCategories };
      delete transactionCategories[id];
      this.transactionCategories = transactionCategories;
    },
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    clear() {
      this.clearUnsubs();
      this.transactionCategories = {};
    },
    registerSnapshot() {
      this.clearUnsubs();
      const snapshotQuery = collection(firestore, 'transactionCategories');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          snapshot.docChanges().forEach((element) => {
            const elementData = { ...element.doc.data() };
            elementData.id = element.doc.id;
            if (element.type === 'added' || element.type === 'modified') {
              this.upsert({ id: element.doc.id, value: elementData });
            } else {
              this.remove(element.doc.id);
            }
          });
        },
        (error) => {
          console.error('TransactionCategory - Error registering snapshot', error);
        }
      );
      this.unsubs.push(unsub);
    },
  },
});
